/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
class s{constructor(s,i,t,e){this.vao=s,this.primitiveType=i,this.parameters=t,this.indexed=e}dispose(){this.vao.dispose()}}export{s as RenderGeometry};
